import { PureComponent, ReactNode } from 'react';

import { Repository } from 'src/components/types';

import { SrcDirMetadata } from '../types';

type SourceDirectoryProps = {
  children?: ReactNode;
  fetchSrcDirMetadata: (
    repository: Repository,
    ref: string,
    path: string
  ) => void;
  hash: string | null | undefined;
  srcDirMetadata: SrcDirMetadata | null | undefined;
  path: string | null | undefined;
  repository: Repository | null | undefined;
};

export default class SourceDirectory extends PureComponent<SourceDirectoryProps> {
  componentDidMount() {
    this.fetchSrcDirMetadata();
  }

  componentDidUpdate(prevProps: SourceDirectoryProps) {
    const { hash, path, repository } = this.props;
    if (
      hash !== prevProps.hash ||
      path !== prevProps.path ||
      (repository &&
        (!prevProps.repository ||
          repository.uuid !== prevProps.repository.uuid))
    ) {
      this.fetchSrcDirMetadata();
    }
  }

  fetchSrcDirMetadata() {
    const { hash, srcDirMetadata, path, repository } = this.props;

    if (
      hash &&
      path &&
      repository &&
      (!srcDirMetadata || (!srcDirMetadata.isLoading && !srcDirMetadata.data))
    ) {
      this.props.fetchSrcDirMetadata(repository, hash, path || '/');
    }
  }

  render() {
    return this.props.children || null;
  }
}
